import * as React from "react";
import { Input } from "reactstrap";

import { NivelEducativoDestinoListItem } from "../models/dataModels";
import { AlertsService } from "../utils/AlertsService";
import { ComponentBase } from "../utils/base/ComponentBase";
import { I18n } from "../utils/I18n";
import { CursoEscolarService } from "./CursoEscolarService";

interface NivelDestinoDropDownProps {
    id: string;
    value?: number;

    /** Niveles que no se pueden elegir: el que se está borrando y los demás marcados para borrar. */
    excluirNivelIds?: number[];

    invalid?: boolean;

    onChange: (nivelEducativoId: number, nivel: NivelEducativoDestinoListItem) => void;
}

interface NivelDestinoDropDownState {
    loading: boolean;
    niveles: NivelEducativoDestinoListItem[];
}

/**
 * Desplegable con los niveles educativos del colegio, agrupados por curso escolar y etapa, para
 * elegir a dónde se mueven los estudiantes de la tienda de un nivel que se va a borrar.
 *
 * No usa la caché estática de NivelEducativoDropDown a propósito: aquí hace falta el dato fresco
 * (el árbol de niveles se está editando justo ahora) y de todos los cursos escolares, no de uno.
 */
export class NivelDestinoDropDown extends ComponentBase<NivelDestinoDropDownProps, NivelDestinoDropDownState> {

    constructor(props: NivelDestinoDropDownProps) {
        super(props);

        this.state = {
            loading: true,
            niveles: []
        };
    }

    componentDidMount() {
        var service = new CursoEscolarService();
        service.getNivelesDestino()
            .then(niveles => {
                this.setState({
                    loading: false,
                    niveles: niveles || []
                });
            })
            .catch(error => {
                // Sin esto, un fallo de la petición se vería como "no hay cursos de destino" y el
                // usuario no podría avanzar ni entender por qué.
                this.setState({ loading: false }, () => AlertsService.showError(error));
            });
    }

    render() {

        if (this.state.loading) {
            return <span>...</span>;
        }

        var excluidos = this.props.excluirNivelIds || [];
        var seleccionables = this.state.niveles.filter(nivel => excluidos.indexOf(nivel.nivelEducativoId) < 0);

        var options = [] as JSX.Element[];

        options.push(<option key="vacio" value="">{I18n.Strings.nivelEducativo.nivelDestinoVacio}</option>);

        var cursoEscolarPintado: number = null;
        var etapaPintada: number = null;

        seleccionables.forEach(nivel => {

            if (cursoEscolarPintado !== nivel.cursoEscolarId) {
                cursoEscolarPintado = nivel.cursoEscolarId;
                etapaPintada = null;

                options.push(<option key={`curso${nivel.cursoEscolarId}`} disabled>
                    {I18n.Strings.nivelEducativo.cursoEscolarDeDestino(nivel.cursoEscolar, nivel.cursoEscolarActivo)}
                </option>);
            }

            if (etapaPintada !== nivel.etapaId) {
                etapaPintada = nivel.etapaId;

                options.push(<option key={`curso${nivel.cursoEscolarId}etapa${nivel.etapaId}`} disabled>
                    &nbsp; &nbsp; {nivel.etapa}
                </option>);
            }

            options.push(<option key={`nivel${nivel.nivelEducativoId}`} value={nivel.nivelEducativoId}>
                &nbsp; &nbsp; &nbsp; &nbsp; {nivel.nivelEducativo}
            </option>);
        });

        return <Input
            type="select"
            id={this.props.id}
            name={this.props.id}
            invalid={this.props.invalid}
            value={this.props.value == null ? "" : this.props.value}
            onChange={(e) => {
                var valor = e.currentTarget.value;
                var nivelEducativoId = valor === "" ? null : parseInt(valor);
                var nivel = this.state.niveles.filter(n => n.nivelEducativoId === nivelEducativoId)[0];

                this.props.onChange(nivelEducativoId, nivel);
            }}
        >
            {options}
        </Input>;
    }
}
